import moment from "moment-timezone";

function getTimes(t) {
  return Number(String(t || '').replace(':', '')) // "06:30" -> 630, "24:30" -> 2430
}

function isOvernightRange(from, to) {
  const f = getTimes(from)
  const t = getTimes(to)
  // 24:xx (ex: 24:30) OR 일반적인 자정넘김(22:00~02:00)
  return t >= 2400 || t < f
}

function inRangeSameDay(nowNum, from, to) {
  const f = getTimes(from)
  let t = getTimes(to)

  if (t === 2400) t = 2359

  // 24:xx -> 00:xx로 내림 (2430 -> 30)
  if (t >= 2400) t -= 2400

  // 같은날 구간
  if (f <= t) return nowNum >= f && nowNum <= t

  // 자정 넘어감 (22:00~02:00)
  return nowNum >= f || nowNum <= t
}

function checkDay(dayObj, nowNum, onlyOvernight) {
  if (!dayObj || !dayObj.available || !Array.isArray(dayObj.time)) return false

  return dayObj.time.some(({ from, to }) => {
    if (onlyOvernight && !isOvernightRange(from, to)) return false
    return inRangeSameDay(nowNum, from, to)
  })
}

/**
 * availableTime: [{id:'mon', available:true, time:[{from,to}]}, ...] (index 0=mon)
 * nowMoment: moment()
 */
export function isAvailableNow(availableTime, nowMoment) {
  if (!Array.isArray(availableTime) || !nowMoment || !moment.isMoment(nowMoment)) return false

  const today = nowMoment.isoWeekday() - 1
  const yesterday = (today + 6) % 7
  const nowNum = getTimes(nowMoment.format('HH:mm'))

  // 1) 오늘 구간
  if (checkDay(availableTime[today], nowNum, false)) return true

  // 2) 어제 구간 중 “익일로 넘어가는 구간”만
  if (checkDay(availableTime[yesterday], nowNum, true)) return true

  return false
}